import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import { ensureTransaction } from '../../../util/data';
import { propTypes } from '../../../util/types';
import capitalize from 'lodash/capitalize';

import css from './TimelineSection.css';
import { formatTransitionName } from '../../../util/transaction';
import { formatDate } from '../../../util/dates';
import { getStateFromLastTransition } from '../../../util/customTransaction/mainRentalTransaction';

const TimelineSection = ({ transaction: tx }) => {
  const intl = useIntl();
  const transaction = ensureTransaction(tx);
  const { attributes } = transaction;
  const { transitions, lastTransition } = attributes;
  const nextPosibleTransitions = getStateFromLastTransition(tx);
  const isEndTransition = !nextPosibleTransitions;
  const finishTransitions = isEndTransition
    ? transitions
    : transitions.filter(transition => transition.transition !== lastTransition);

  return (
    <div className={css.timeline}>
      <h2 className={css.sectionTitle}>
        <FormattedMessage id="AMTxPage.timeline" defaultMessage="Timeline" />
      </h2>
      {!isEndTransition && (
        <div className={css.sectionContent}>
          <div className={classNames(css.item, css.itemCurrent)}>
            <div className={css.transitionName}>
              <FormattedMessage
                id="AMTxPage.nextPosibleTransition"
                defaultMessage="Next posible transitions:"
              />
            </div>
            {nextPosibleTransitions.map(item => {
              const isAdminAction = item.toLowerCase().includes('/admin-');
              return (
                <div key={item} className={css.subItem}>
                  <div
                    className={classNames(css.transitionName, {
                      [css.adminAction]: isAdminAction,
                    })}
                  >
                    {formatTransitionName(item)}
                  </div>
                  <div className={css.transitionMoreDetail}>
                    {isAdminAction && (
                      <FormattedMessage id="AMTxPage.operatorRole" defaultMessage="Operator" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className={css.sectionContent}>
        {[...finishTransitions].reverse().map(transition => {
          const formattedTransitionName = formatTransitionName(transition.transition);
          const actor = capitalize(transition.by);
          const createdAtText = formatDate(intl, 'Today', transition.createdAt);

          return (
            <div key={transition.transition} className={css.item}>
              <div className={css.transitionName}>{formattedTransitionName}</div>
              <div className={css.transitionMoreDetail}>{`${actor}, ${createdAtText}`}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

TimelineSection.propTypes = {
  transaction: propTypes.transaction,
};

export default TimelineSection;
